<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">{{
          $t('tableActivator.table')
        }}</label>
        <a-select v-model="model.table_id" :options="tableProfiles" show-search option-filter-prop="children"
          class="ts-w-full" :class="{ 'is-invalid': errors.has('table_id') }" placeholder="Select" disabled></a-select>
        <div class="validate" v-if="errors.has('table_id')">
          {{ errors.first('table_id') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">{{
          $t('tableActivator.serialCard')
        }}</label>
        <input v-model.trim="model.serial_card" type="text" class="form-control"
          :class="{ 'is-invalid': errors.has('serial_card') }" style="height: 32px;" disabled />
        <div class="validate" v-if="errors.has('serial_card')">
          {{ errors.first('serial_card') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">
          {{ $t('tableActivator.status') }}
        </label>
        <a-select v-model="model.status_id" :options="statusList" show-search option-filter-prop="children"
          class="ts-w-full" :class="{ 'is-invalid': errors.has('status_id') }" placeholder="Select"></a-select>
        <div class="validate" v-if="errors.has('status_id')">
          {{ errors.first('status_id') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">{{
          $t('tableActivator.activateDate')
        }}</label>
        <a-date-picker v-model="model.activate_date" class="ts-w-full" show-time format="DD-MM-YYYY HH:mm:ss"
          valueFormat="DD-MM-YYYY HH:mm:ss" :class="{ 'is-invalid': errors.has('activate_date') }"></a-date-picker>
        <div class="validate" v-if="errors.has('activate_date')">
          {{ errors.first('activate_date') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-mb-0 ts-text-xs">{{
          $t('tableActivator.expiryDate')
        }}</label>
        <a-date-picker v-model="model.expiry_date" class="ts-w-full" show-time format="DD-MM-YYYY HH:mm:ss"
          valueFormat="DD-MM-YYYY HH:mm:ss" :class="{ 'is-invalid': errors.has('expiry_date') }"></a-date-picker>
        <div class="validate" v-if="errors.has('expiry_date')">
          {{ errors.first('expiry_date') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">{{
          $t('tableActivator.remark')
        }}</label>
        <textarea v-model="model.remark" rows="3" class="form-control" :class="{ 'is-invalid': errors.has('remark') }"
          placeholder="Note something here"></textarea>
        <div class="validate" v-if="errors.has('remark')">
          {{ errors.first('remark') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2 ts-mt-3">
        <ts-button :disabled="loading" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button v-if="isUpdate" color="primary" @click.prevent="onCheckExist" :disabled="loading">
          {{ $t('update') }}
        </ts-button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>

    <!-- form-action -->
    <a-modal v-if="exist" v-model="exist" centered :header="null" :zIndex="1020" :footer="null" :closable="false"
      width="400px">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="ts-flex ts-items-center ts-gap-3 ts-px-4 ts-pb-3 ts-border-b ts-border-gray-200 ts-w-full">
            <div class="ts-flex-shrink-0">
              <i class="fas fa-exclamation ts-text-orange-500"></i>
            </div>
            <b class="ts-text-sm ts-font-medium ts-text-gray-900">
              Are you sure ?
            </b>
          </div>

          <div class="ts-px-2 ts-pt-2 ts-pb-1 ts-w-full">
            <span class="ts-text-sm ts-text-gray-600">
              This table is already activated with other serial card. Do you want to overwirte it?
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-mb-0 ts-text-xs">{{
              $t('tableActivator.remark')
            }}</label>
            <textarea v-model="model.remark" rows="3" class="form-control"
              :class="{ 'is-invalid': errors.has('remark') }" placeholder="Note something here"></textarea>
            <div class="validate" v-if="errors.has('table_id')">
              {{ errors.first('table_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2 ts-mt-3">
            <ts-button :disabled="loading" @click.prevent="() => exist = false">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button :disabled="loading" @click.prevent="onConfirm" outline color="primary">
              {{ $t('confirm') }}
            </ts-button>
          </div>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'tableActivatorForm',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      exist: false,
      model: {
        activator_id: null,
        table_id: null,
        serial_card: null,
        activate_date: moment().format('DD-MM-YYYY HH:mm:ss'),
        expiry_date: null,
        status_id: 1,
        remark: null,
        overwirte: false,
      }
    }
  },
  created() {
    this.setEditData()
    this.fetchData()
  },
  computed: {
    ...mapState('booking/tableActivator', ['edit_data', 'formViewData']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
    tableProfiles() {
      if (this.formViewData.tableProfiles) {
        return this.formViewData.tableProfiles.map(el => ({
          label: 'Table: ' + el.table_no + '| Guest Type: ' + el.guest_level_name_en + '| Floor: ' + el.floors,
          value: el.table_id
        }))
      }
      return []
    },
    statusList() {
      return [
        { label: 'Active', value: 1 },
        { label: 'Inactive', value: 2 }
      ]
    }
  },
  methods: {
    ...mapActions('booking/tableActivator', ['getFormViewData']),
    async fetchData() {
      this.loading = true
      await this.getFormViewData({
        params: undefined,
        index: undefined
      }).finally(() => (this.loading = false))
    },
    async onCheckExist() {
      this.loading = true
      await this.$store
      this.$store
        .dispatch('booking/tableActivator/checkExist', this.model)
        .then(response => {
          this.exist = response.exist;
          if (response.exist) {
            this.loading = false
          } else {
            this.onUpdate()
          }
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    onConfirm() {
      this.model.overwirte = true
      this.onUpdate()
    },
    onUpdate() {
      this.loading = true
      this.$store
        .dispatch('booking/tableActivator/update', {
          id: this.model.activator_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          // console.log(error);

          this.model.overwirte = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.activator_id = this.edit_data.activator_id
        this.model.table_id = this.edit_data.table_id
        this.model.serial_card = this.edit_data.serial_card
        this.model.activate_date = this.edit_data.activate_date ? moment(this.edit_data.activate_date, "DD-MM-YYYY hh:mm:ss A").format("DD-MM-YYYY HH:mm:ss") : null
        this.model.expiry_date = this.edit_data.expiry_date ? moment(this.edit_data.expiry_date, "DD-MM-YYYY hh:mm:ss A").format("DD-MM-YYYY HH:mm:ss") : null
        this.model.status_id = this.edit_data.status_id
        this.model.remark = this.edit_data.remark
      }
    },
    clearInput() {
      this.model.activator_id = null
      this.model.table_id = null
      this.model.serial_card = null
      this.model.activate_date = moment().format('DD-MM-YYYY HH:mm:ss')
      this.model.expiry_date = null
      this.model.status_id = 1
      this.model.remark = null
      this.model.overwirte = false
      this.$store.commit('booking/tableActivator/SET_EDIT_DATA', {})
    }
  }
}
</script>
<style>
.ant-calendar-picker-input {
  height: 32px !important;
}
</style>